import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmationComponent } from '@shared/confirmation/confirmation.component';
import { ToastComponent } from '@shared/toast/toast.component';
import { MapActionService } from '@features/map/services/map-action.service';
import { AuthService } from '@core/auth/services/auth.service';
import { filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, ConfirmationComponent, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private readonly auth: AuthService,
    private readonly action: MapActionService
  ) {}

  ngOnInit(): void {
    this.auth
      .isLoggedIn()
      .pipe(
        filter(Boolean),
        switchMap(() => this.action.load())
      )
      .subscribe();
  }
}
